import { useColorModeValue } from "@chakra-ui/react";
import { ArrowUpFromLine, ArrowDownFromLine, ArrowDownUp } from "lucide-react";

export const TableOrderIcon = ({
  orderedKey,
  orderType,
  elementKey,
}: {
  orderedKey: string;
  orderType: "asc" | "des";
  elementKey: string;
}) => {
  const color = useColorModeValue("var(--chakra-colors-brand-500)", "white");
  return orderedKey !== "" ? (
    orderedKey === elementKey ? (
      orderType === "asc" ? (
        <ArrowUpFromLine color={color} size={17} />
      ) : (
        <ArrowDownFromLine color={color} size={17} />
      )
    ) : (
      <ArrowDownUp color={color} size={17} />
    )
  ) : (
    <ArrowDownUp color={color} size={17} />
  );
};
